import React, {useEffect} from 'react';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {PaymentRequestView} from '../PaymentRequestView';
import {useControllerProps} from '../../Widget/ControllerContext';
import {ErrorMessage} from '../../constants';
import {classes} from './VoidedErrorView.st.css';
import {Button} from 'wix-ui-tpa';

export enum VoidedErrorViewDataHook {
  Root = 'VoidedErrorViewDataHook.root',
  View = 'VoidedErrorViewDataHook.view',
  Button = 'VoidedErrorViewDataHook.button',
}

export const VoidedErrorView = () => {
  const {
    paymentRequestStore: {paymentRequest, sendPaymentRequestErrorPageLoadBIEvent, sendClickOnVoidedErrorButtonBIEvent},
    navigationStore: {navigateToUrl},
  } = useControllerProps();
  const localeKeys = useLocaleKeys();

  const handleOnClick = () => {
    sendClickOnVoidedErrorButtonBIEvent(ErrorMessage.VOIDED_ERROR);
    navigateToUrl();
  };

  useEffect(
    () => {
      sendPaymentRequestErrorPageLoadBIEvent(ErrorMessage.VOIDED_ERROR);
    },
    /* eslint-disable react-hooks/exhaustive-deps */ []
  );

  const ActionLinkError = paymentRequest.actionLinks?.error;
  const label = ActionLinkError?.label;

  return (
    <div className={classes.container} data-hook={VoidedErrorViewDataHook.Root}>
      <PaymentRequestView
        dataHook={VoidedErrorViewDataHook.View}
        title={localeKeys.checkout.invoiceVoided.error.title()}
        subtitle={localeKeys.checkout.invoiceVoided.error.subtitle()}
      />
      {ActionLinkError && (
        <Button className={classes.button} data-hook={VoidedErrorViewDataHook.Button} onClick={handleOnClick}>
          {label}
        </Button>
      )}
    </div>
  );
};
